import React from 'react'
import { Box, Skeleton, Stack, Divider } from '@mui/material'

function PhysiansLoading () {
  return (
    <Box
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        p: 3,
        width: '100%',
        backgroundColor: '#ffffff',
        mx: 'auto'
      }}
    >
      <Skeleton variant='text' width={200} height={40} sx={{ mb: 3 }} />

      <Divider sx={{ mb: 3 }} />

      <Skeleton variant='text' width={300} height={30} sx={{ mb: 4 }} />

      <Box sx={{ mb: 4 }}>
        {['Name*', 'License Number*', 'Document ID', 'Speciality*'].map(
          (label, index) => (
            <Box
              key={index}
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 2,
                mb: 2,
                alignItems: 'center'
              }}
            >
              <Skeleton variant='text' width={120} height={25} />
              <Skeleton variant='rectangular' width='100%' height={40} />
            </Box>
          )
        )}
      </Box>

      <Box sx={{ mb: 4 }}>
        <Skeleton variant='text' width={80} height={25} sx={{ mb: 1 }} />
        <Skeleton variant='rectangular' width={200} height={40} />
      </Box>

      <Stack direction='row' spacing={2} justifyContent='flex-end'>
        <Skeleton variant='rounded' width={100} height={36} />
        <Skeleton variant='rounded' width={100} height={36} />
      </Stack>
    </Box>
  )
}

export default PhysiansLoading
